<template>
    <div v-show="show">
        <div tabindex="-1" role="dialog" class="el-message-box__wrapper"
             style="z-index: 2007;">
            <div class="el-message-box">
                <div class="el-message-box__header">
                    <div v-if="title" class="el-message-box__title"><span>{{title}}</span></div>
                    <button @click="show = false" type="button" class="el-message-box__headerbtn">
                        <i class="el-message-box__close el-icon-close"></i>
                    </button>
                </div>

                <slot></slot>

                <div class="el-message-box__btns">
                    <el-button size="small" @click="cancelFunc">取消</el-button>
                    <el-button size="small" type="primary" @click="submitFunc">确认</el-button>
                </div>
            </div>
        </div>
        <div class="v-modal" tabindex="0" style="z-index: 2006;"></div>
    </div>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            cancelFunc() {
                this.$emit('my-cancel', () => {
                    this.show = false;
                })
            },
            submitFunc() {
                this.$emit('my-submit', () => {
                    this.show = false;
                })
            }
        }
    }
</script>